// if you want to add more need to add it to translation

enum ScheduleLessonTypes {
	Life = 'Live lesson',
	Platform = 'Self-study',
	Webinar = 'Webinar',
}

export type ScheduleLessonType = `${ScheduleLessonTypes}`;

export default ScheduleLessonTypes;
